import { defineComponent, inferProps, useOnInputNumber, type ReactiveComponent } from "vue-utils"
import type { GenericInputProps } from "./InputComponent"

type Props = GenericInputProps<number>

const NumberInput: ReactiveComponent<Props> = (props) => {
	return () => <input type="number" value={props.value} onInput={useOnInputNumber(props.setValue)} required />
}

export default defineComponent(NumberInput, inferProps<Props>())
